import { DataType } from '@doss/prisma/types'

export const UNIQUE_CONSTRAINT_ALLOWED_COLUMN_TYPES = [
  DataType.STRING,
  DataType.ENUM,
  DataType.NUMBER,
  DataType.DATE,
  DataType.DATE_TIME,
  DataType.ID,
  DataType.BOOLEAN,
  DataType.LOOKUP,
] as const

export type UniqueConstraintAllowedColumnType =
  (typeof UNIQUE_CONSTRAINT_ALLOWED_COLUMN_TYPES)[number]

/** Stable code for writes rejected by a table unique constraint. */
export const UNIQUE_CONSTRAINT_VIOLATION_CODE = 'UNIQUE_CONSTRAINT_VIOLATION'

export enum UniqueConstraintViolationReason {
  DUPLICATE = 'DUPLICATE',
  KEY_TOO_LARGE = 'KEY_TOO_LARGE',
}

export const MAX_UNIQUE_CONSTRAINTS_PER_TABLE = 3
export const MAX_COLUMNS_PER_UNIQUE_CONSTRAINT = 3

// Conflict evidence caps, enforced by the duplicate probe in common-z-tables; frontend-readable
export const MAX_REPORTED_DUPLICATE_KEY_GROUPS = 5
export const MAX_EXAMPLE_ROWS_PER_DUPLICATE_KEY_GROUP = 5

export const isUniqueConstraintAllowedColumnType = (
  type: DataType,
): type is UniqueConstraintAllowedColumnType => {
  return UNIQUE_CONSTRAINT_ALLOWED_COLUMN_TYPES.includes(type as UniqueConstraintAllowedColumnType)
}
